import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useDispatch } from "react-redux";
import { Control } from "../../../control/control";
import { DEFAULT_WIND_IN_DELAY_MIN, DEFAULT_WIND_IN_DELAY_MAX, DEFAULT_LAYERS, } from "@erikwatson/snowfall";
import { Range } from "../../../range/range";
import { setWindGustsInDelayMin, setWindGustsInDelayMax, } from "../../../../features/config/config.slice";
import { ControlGroup } from "../../../controlGroup/controlGroup";
import { Group } from "../../../group/group";
export const SnowflakeGustInDelay = ({ index, layer, }) => {
    const dispatch = useDispatch();
    return (_jsx(_Fragment, { children: _jsx(Group, { colour: "secondary", name: "Delay", children: _jsxs(ControlGroup, { children: [_jsx(Control, { name: "Minimum", tooltip: "The minimum delay, in ms, before the wind begins to gust", showOutput: true, reset: () => {
                            const min = index < DEFAULT_LAYERS.length
                                ? DEFAULT_LAYERS[index].wind.gusts.in.delay.min
                                : DEFAULT_WIND_IN_DELAY_MIN;
                            dispatch(setWindGustsInDelayMin({
                                index,
                                min,
                            }));
                        }, value: layer.wind.gusts.in.delay.min, onChange: (event) => dispatch(setWindGustsInDelayMin({
                            index,
                            min: Number(event.target.value),
                        })), children: _jsx(Range, { min: 0, max: 100, step: 1 }) }), _jsx(Control, { name: "Maximum", tooltip: "The maximum delay, in ms, before the wind begins to gust", showOutput: true, reset: () => {
                            const max = index < DEFAULT_LAYERS.length
                                ? DEFAULT_LAYERS[index].wind.gusts.in.delay.max
                                : DEFAULT_WIND_IN_DELAY_MAX;
                            dispatch(setWindGustsInDelayMax({
                                index,
                                max,
                            }));
                        }, value: layer.wind.gusts.in.delay.max, onChange: (event) => dispatch(setWindGustsInDelayMax({
                            index,
                            max: Number(event.target.value),
                        })), children: _jsx(Range, { min: 0, max: 100, step: 1 }) })] }) }, index) }));
};
